module.exports = __webpack_public_path__ + "static/media/superseria_img@2x.ce7e8ec9.png";